<template>
  <NotFound v-if="typeCheck === 'error'" />
  <main class="main-content-area" v-else>
    <!-- Promotion banner section -->
    <section
      class="ct-inner-banner promo-bann pt-26 pb-25"
      :style="{
        background: true ? '#232529' : 'none',
      }"
      v-if="
        promotionPageData &&
        promotionPageData.featured_promotion &&
        promotionPageData.featured_promotion.metadata &&
        promotionPageData.featured_promotion.partner_information &&
        Object.keys(promotionPageData.featured_promotion.partner_information)
          .length > 0
      "
    >
      <div class="container z-con">
        <!--Breadcrumps-->
        <div class="col-md-12">
          <Breadcrumb
            :breadcrumbData="promotionPageData.breadcrumb"
            :dark="getContrastYIQ($root.color_schema.footer_bg)"
          />
        </div>
        <!--End Breadcrumps-->
        <div
          class="wrapper-header"
          v-if="
            promotionPageData.featured_promotion_label &&
            promotionPageData.featured_promotion_label != ''
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="22"
            viewBox="0 0 15 27"
            fill="none"
          >
            <path
              d="M14.5561 9.2487H8.52244L14.1157 0.44043H7.06908L0.462891 13.6528H5.65974L0.462891 25.9844L14.5561 9.2487Z"
              fill="#FFDD09"
            />
            <path
              d="M8.83071 0.44043H7.06908L0.462891 13.6528H2.22452L8.83071 0.44043Z"
              fill="white"
            />
            <path
              d="M12.3535 9.24866L1.78361 21.8004L0.0219727 25.9844L14.1151 9.24866H12.3535Z"
              fill="#FD9808"
            />
            <path
              d="M0.462446 26.4248C0.374346 26.4248 0.286298 26.4248 0.242223 26.3807C0.0660749 26.2486 -0.0220249 26.0284 0.0660748 25.8522L4.99868 14.0932H0.462446C0.330322 14.0932 0.154174 14.0051 0.0660748 13.873C-0.0220249 13.7409 -0.0220249 13.5647 0.0660748 13.4326L6.67226 0.220223C6.76036 0.0880997 6.89249 0 7.06863 0H14.1152C14.2914 0 14.4235 0.0880997 14.5116 0.220223C14.5997 0.352347 14.5997 0.528495 14.5116 0.660619L9.35876 8.80827H14.5556C14.7318 8.80827 14.8639 8.89637 14.952 9.07252C15.0401 9.24866 14.996 9.42486 14.908 9.55699L0.814742 26.2926C0.726694 26.3807 0.59457 26.4248 0.462446 26.4248ZM1.16709 13.2124H5.6593C5.79142 13.2124 5.92354 13.3005 6.01164 13.3885C6.09974 13.5206 6.09974 13.6528 6.05567 13.7849L2.00386 23.474L13.6307 9.68906H8.52194C8.3458 9.68906 8.21367 9.60096 8.12557 9.46883C8.03747 9.33671 8.03747 9.16056 8.12557 9.02844L13.3225 0.880842H7.33288L1.16709 13.2124Z"
              fill="black"
            />
          </svg>
          <h1 class="custom-font-1 hd-span">
            {{ promotionPageData.featured_promotion_label }}
          </h1>
        </div>
        <div
          class="offer-wrapper"
          v-if="promotionPageData.featured_promotion.metadata"
        >
          <div class="offer-card offer-card-big suggested">
            <div class="offer-card-bg">
              <img
                class="img-desktop"
                :src="
                  promotionPageData.featured_promotion.metadata
                    .desktop_header_image
                "
                :alt="
                  promotionPageData.featured_promotion.metadata.partner
                    ? getAltText(
                        promotionPageData.featured_promotion.metadata.partner
                          .post_title,
                        promotionPageData.featured_promotion.metadata
                          .desktop_header_image
                      )
                    : 'Header Desktop Image'
                "
              />
              <img
                class="img-mobile"
                :src="
                  promotionPageData.featured_promotion.metadata
                    .mobile_header_image
                "
                :alt="
                  promotionPageData.featured_promotion.metadata.partner
                    ? getAltText(
                        promotionPageData.featured_promotion.metadata.partner
                          .post_title,
                        promotionPageData.featured_promotion.metadata
                          .desktop_header_image
                      )
                    : 'Header Mobile Image'
                "
              />
            </div>
            <div
              class="offer-card-meta"
              v-if="promotionPageData.featured_promotion.partner_information"
            >
              <div class="offer-card-logo">
                <a
                  v-if="
                    promotionPageData.featured_promotion.partner_information
                      .go_link
                  "
                  :title="
                    promotionPageData.featured_promotion.partner_information
                      .product_name
                  "
                  :href="
                    getGoLink(
                      promotionPageData.featured_promotion.partner_information
                        .go_link,
                      promotionPageData.featured_promotion.partner_information
                        .slug
                    )
                  "
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  target="_blank"
                  class="affiliate-logo partner-logo pt-100 cas-link"
                >
                  <img
                    v-if="
                      promotionPageData.featured_promotion.partner_information
                        .product_assets &&
                      getPartnerImg(
                        promotionPageData.featured_promotion.partner_information
                          .product_assets
                      )
                    "
                    :src="
                      getPartnerImg(
                        promotionPageData.featured_promotion.partner_information
                          .product_assets
                      )
                    "
                    :alt="
                      getAltText(
                        promotionPageData.featured_promotion.partner_information
                          .product_name,
                        getPartnerImg(
                          promotionPageData.featured_promotion
                            .partner_information.product_assets
                        )
                      )
                    "
                  />
                  <div class="partner-hover wd-promo">
                    <div
                      class="partner-hover-inner"
                      :style="{
                        '--primary-btn': $root.color_schema.primary_btn,
                        '--primary-btn-hover': pSBC(
                          -0.2,
                          $root.color_schema.primary_btn
                        ),
                      }"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="16"
                        viewBox="0 0 10 16"
                        fill="none"
                      >
                        <path
                          d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </div>
                </a>
              </div>
              <div class="offer-card-title">
                <template v-if="$root.enable_piwik_reload">
                  <a
                    :title="
                      promotionPageData.featured_promotion.partner_information
                        .product_name
                    "
                    class="partner-name custom-font-1 text-hover"
                    v-if="
                      promotionPageData.featured_promotion.partner_information
                        .review_link
                    "
                    :href="
                      getRouteLink(
                        promotionPageData.featured_promotion.partner_information
                          .review_link,
                        'review'
                      )
                    "
                  >
                    <span
                      >{{
                        getPartnerGlobalString(
                          $root.i18n.partner_name_review,
                          promotionPageData.featured_promotion
                            .partner_information.product_name
                        )
                      }}
                    </span>
                  </a>
                  <span class="partner-name custom-font-1" v-else>{{
                    promotionPageData.featured_promotion.partner_information
                      .product_name
                  }}</span>
                </template>
                <template v-else>
                  <router-link
                    :title="
                      promotionPageData.featured_promotion.partner_information
                        .product_name
                    "
                    class="partner-name custom-font-1 text-hover"
                    v-if="
                      promotionPageData.featured_promotion.partner_information
                        .review_link
                    "
                    :to="
                      getRouteLink(
                        promotionPageData.featured_promotion.partner_information
                          .review_link,
                        'review'
                      )
                    "
                  >
                    <span
                      >{{
                        getPartnerGlobalString(
                          $root.i18n.partner_name_review,
                          promotionPageData.featured_promotion
                            .partner_information.product_name
                        )
                      }}
                    </span>
                  </router-link>
                  <span class="partner-name custom-font-1" v-else>{{
                    promotionPageData.featured_promotion.partner_information
                      .product_name
                  }}</span>
                </template>
                <StarRating
                  :rating="
                    parseFloat(
                      (
                        promotionPageData.featured_promotion.partner_information
                          .rating / 2
                      ).toFixed(1)
                    )
                  "
                  :classParam="strCls"
                />
              </div>
            </div>
            <div class="offer-card-tags">
              <span class="pro-promotion-tag">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                >
                  <path
                    d="M7.97849 4.95613C7.94088 4.87537 7.85987 4.82354 7.77065 4.82354H5.05211L7.73508 0.587447C7.77981 0.516795 7.78256 0.427324 7.7422 0.354146C7.70182 0.280725 7.62472 0.235291 7.54122 0.235291H3.87063C3.78369 0.235291 3.7043 0.284381 3.66532 0.362157L0.224142 7.24451C0.188574 7.31541 0.192472 7.39982 0.234223 7.46749C0.276217 7.53516 0.349852 7.57645 0.429457 7.57645H2.78849L0.217931 13.6816C0.17411 13.786 0.213119 13.9071 0.309687 13.9663C0.346841 13.989 0.388135 14 0.429214 14C0.495054 14 0.559979 13.9718 0.604957 13.9185L7.94615 5.20088C8.00371 5.13254 8.0161 5.03711 7.97849 4.95613Z"
                    fill="black"
                  />
                  <path
                    d="M7.97849 4.95613C7.94088 4.87537 7.85987 4.82354 7.77065 4.82354H5.05211L7.73508 0.587447C7.77981 0.516795 7.78256 0.427324 7.7422 0.354146C7.70182 0.280725 7.62472 0.235291 7.54122 0.235291H3.87063C3.78369 0.235291 3.7043 0.284381 3.66532 0.362157L0.224142 7.24451C0.188574 7.31541 0.192472 7.39982 0.234223 7.46749C0.276217 7.53516 0.349852 7.57645 0.429457 7.57645H2.78849L0.217931 13.6816C0.17411 13.786 0.213119 13.9071 0.309687 13.9663C0.346841 13.989 0.388135 14 0.429214 14C0.495054 14 0.559979 13.9718 0.604957 13.9185L7.94615 5.20088C8.00371 5.13254 8.0161 5.03711 7.97849 4.95613Z"
                    fill="black"
                  />
                </svg>
                {{ $root.i18n.promotion }}
              </span>
              <span class="pro-suggestion-tag">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M10.4896 9.65479C10.2314 9.65479 10.0217 9.4458 10.021 9.18738C10.0201 8.92859 10.2294 8.71802 10.4883 8.71729C11.6658 8.71362 12.786 8.00269 13.6426 6.71533C14.4647 5.47974 14.9478 3.86389 15.0214 2.12354H12.9567C12.6978 2.12354 12.4879 1.9137 12.4879 1.65479C12.4879 1.39587 12.6978 1.18604 12.9567 1.18604H15.5C15.7589 1.18604 15.9688 1.39587 15.9688 1.65479C15.9688 3.75513 15.4198 5.73669 14.4232 7.23474C13.3878 8.79065 11.9915 9.65015 10.4912 9.65479C10.4907 9.65479 10.4902 9.65479 10.4896 9.65479Z"
                      fill="#FF8E1D"
                    />
                    <path
                      d="M5.44788 9.65479C5.44727 9.65479 5.4469 9.65479 5.44641 9.65479C3.94617 9.65015 2.54968 8.79065 1.5144 7.23474C0.5177 5.73669 -0.03125 3.75513 -0.03125 1.65479C-0.03125 1.39587 0.178589 1.18604 0.4375 1.18604H2.98084C3.23975 1.18604 3.44959 1.39587 3.44959 1.65479C3.44959 1.9137 3.23975 2.12354 2.98084 2.12354H0.916138C0.989746 3.86389 1.47278 5.47974 2.29492 6.71533C3.15149 8.00269 4.27173 8.71362 5.44922 8.71729C5.70813 8.71802 5.91736 8.92859 5.91651 9.18738C5.91577 9.4458 5.70606 9.65466 5.44788 9.65479Z"
                      fill="#FFB023"
                    />
                    <path
                      d="M12.9897 0.03125H2.948C2.68921 0.03125 2.47925 0.241089 2.47925 0.5C2.47925 3.25354 3.01917 5.84973 3.99939 7.81018C4.62744 9.06616 5.39551 9.97791 6.24487 10.4999V13.052C6.24487 13.3109 6.45483 13.5208 6.71362 13.5208H9.22412C9.48303 13.5208 9.69287 13.3109 9.69287 13.052V10.4999C10.5422 9.97803 11.3104 9.06616 11.9384 7.81018C12.9186 5.84973 13.4585 3.25354 13.4585 0.5C13.4585 0.241089 13.2487 0.03125 12.9897 0.03125Z"
                      fill="#FFD12B"
                    />
                    <path
                      d="M9.69275 13.052V10.4999C10.5421 9.97803 11.3103 9.06616 11.9382 7.81018C12.9185 5.84973 13.4584 3.25354 13.4584 0.5C13.4584 0.241089 13.2485 0.03125 12.9896 0.03125H7.96875V13.5208H9.224C9.48291 13.5208 9.69275 13.3109 9.69275 13.052Z"
                      fill="#FFB023"
                    />
                    <path
                      d="M10.4791 12.5833H5.45837C4.50781 12.5833 3.73438 13.3567 3.73438 14.3073V15.5625C3.73438 15.8213 3.94421 16.0311 4.20312 16.0311H11.7344C11.9933 16.0311 12.2031 15.8213 12.2031 15.5625V14.3073C12.2031 13.3567 11.4298 12.5833 10.4791 12.5833Z"
                      fill="#FF8E1D"
                    />
                    <path
                      d="M10.4791 12.5833H7.96875V16.0311H11.7344C11.9933 16.0311 12.2031 15.8213 12.2031 15.5625V14.3073C12.2031 13.3567 11.4298 12.5833 10.4791 12.5833Z"
                      fill="#FF6D15"
                    />
                    <path
                      d="M12.2363 16.0311H3.70093C3.44214 16.0311 3.23218 15.8213 3.23218 15.5625C3.23218 15.3036 3.44214 15.0938 3.70093 15.0938H12.2363C12.4952 15.0938 12.7051 15.3036 12.7051 15.5625C12.7051 15.8213 12.4952 16.0311 12.2363 16.0311Z"
                      fill="#FFB023"
                    />
                    <path
                      d="M12.2365 15.0938H7.96875V16.0311H12.2365C12.4954 16.0311 12.7052 15.8213 12.7052 15.5625C12.7052 15.3036 12.4954 15.0938 12.2365 15.0938Z"
                      fill="#FF8E1D"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                {{ $root.i18n.suggested }}
              </span>
            </div>
            <div class="offer-card-bonus">
              <div class="mobile-tags">
                <span class="pro-promotion-tag">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="5"
                    height="9"
                    viewBox="0 0 5 9"
                    fill="none"
                  >
                    <path
                      d="M4.98659 3.18601C4.96308 3.13409 4.91245 3.10077 4.85668 3.10077H3.1576L4.83445 0.37757C4.86241 0.332151 4.86413 0.274634 4.83891 0.227591C4.81367 0.180392 4.76548 0.151184 4.71329 0.151184H2.41918C2.36484 0.151184 2.31522 0.182742 2.29086 0.232741L0.140119 4.65711C0.117889 4.70269 0.120326 4.75696 0.14642 4.80046C0.172666 4.84396 0.218688 4.8705 0.268441 4.8705H1.74284L0.136238 8.79522C0.108849 8.86232 0.13323 8.94018 0.193585 8.97824C0.216806 8.99284 0.242615 8.99991 0.26829 8.99991C0.309439 8.99991 0.350018 8.98177 0.378128 8.94756L4.96637 3.34335C5.00235 3.29942 5.01009 3.23807 4.98659 3.18601Z"
                      fill="black"
                    />
                  </svg>
                  {{ $root.i18n.promotion }}
                </span>
                <span class="pro-suggestion-tag">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        d="M5.24506 4.82739C5.11597 4.82739 5.01111 4.7229 5.01074 4.59369C5.01032 4.46429 5.11493 4.35901 5.24439 4.35864C5.83313 4.35681 6.39325 4.00134 6.82154 3.35767C7.23261 2.73987 7.47413 1.93195 7.51093 1.06177H6.47858C6.34913 1.06177 6.24421 0.956848 6.24421 0.827393C6.24421 0.697937 6.34913 0.593018 6.47858 0.593018H7.75025C7.87971 0.593018 7.98463 0.697937 7.98463 0.827393C7.98463 1.87756 7.71015 2.86835 7.21186 3.61737C6.69416 4.39532 5.99598 4.82507 5.24585 4.82739C5.24561 4.82739 5.24536 4.82739 5.24506 4.82739Z"
                        fill="#FF8E1D"
                      />
                      <path
                        d="M2.72394 4.82739C2.72363 4.82739 2.72345 4.82739 2.72321 4.82739C1.97308 4.82507 1.27484 4.39532 0.757202 3.61737C0.25885 2.86835 -0.015625 1.87756 -0.015625 0.827393C-0.015625 0.697937 0.0892945 0.593018 0.21875 0.593018H1.49042C1.61987 0.593018 1.72479 0.697937 1.72479 0.827393C1.72479 0.956848 1.61987 1.06177 1.49042 1.06177H0.458069C0.494873 1.93195 0.736389 2.73987 1.14746 3.35767C1.57574 4.00134 2.13586 4.35681 2.72461 4.35864C2.85407 4.35901 2.95868 4.46429 2.95825 4.59369C2.95789 4.7229 2.85303 4.82733 2.72394 4.82739Z"
                        fill="#FFB023"
                      />
                      <path
                        d="M6.495 0.015625H1.47412C1.34473 0.015625 1.23975 0.120544 1.23975 0.25C1.23975 1.62677 1.5097 2.92487 1.99982 3.90509C2.31384 4.53308 2.69788 4.98895 3.12256 5.24994V6.526C3.12256 6.65546 3.22754 6.76038 3.35693 6.76038H4.61218C4.74164 6.76038 4.84656 6.65546 4.84656 6.526V5.24994C5.27124 4.98901 5.65533 4.53308 5.9693 3.90509C6.45941 2.92487 6.72937 1.62677 6.72937 0.25C6.72937 0.120544 6.62445 0.015625 6.495 0.015625Z"
                        fill="#FFD12B"
                      />
                      <path
                        d="M4.84637 6.526V5.24994C5.27106 4.98901 5.65515 4.53308 5.96912 3.90509C6.45923 2.92487 6.72919 1.62677 6.72919 0.25C6.72919 0.120544 6.62427 0.015625 6.49481 0.015625H3.98438V6.76038H4.612C4.74146 6.76038 4.84637 6.65546 4.84637 6.526Z"
                        fill="#FFB023"
                      />
                      <path
                        d="M5.23956 6.29163H2.72919C2.25391 6.29163 1.86719 6.67835 1.86719 7.15363V7.78126C1.86719 7.91065 1.97211 8.01557 2.10156 8.01557H5.86719C5.99664 8.01557 6.10156 7.91065 6.10156 7.78126V7.15363C6.10156 6.67835 5.7149 6.29163 5.23956 6.29163Z"
                        fill="#FF8E1D"
                      />
                      <path
                        d="M5.23956 6.29163H3.98438V8.01557H5.86719C5.99664 8.01557 6.10156 7.91065 6.10156 7.78126V7.15363C6.10156 6.67835 5.7149 6.29163 5.23956 6.29163Z"
                        fill="#FF6D15"
                      />
                      <path
                        d="M6.11829 8.01557H1.85059C1.72119 8.01557 1.61621 7.91065 1.61621 7.78125C1.61621 7.6518 1.72119 7.54688 1.85059 7.54688H6.11829C6.24774 7.54688 6.35266 7.6518 6.35266 7.78125C6.35266 7.91065 6.24774 8.01557 6.11829 8.01557Z"
                        fill="#FFB023"
                      />
                      <path
                        d="M6.11822 7.54688H3.98438V8.01557H6.11822C6.24768 8.01557 6.3526 7.91065 6.3526 7.78125C6.3526 7.6518 6.24768 7.54688 6.11822 7.54688Z"
                        fill="#FF8E1D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="8" height="8" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  {{ $root.i18n.suggested }}
                </span>
              </div>
              <div class="desk-text">
                <a
                  v-if="
                    promotionPageData.featured_promotion.partner_information
                      .go_link
                  "
                  :title="
                    promotionPageData.featured_promotion.partner_information
                      .product_name
                  "
                  :href="
                    getGoLink(
                      promotionPageData.featured_promotion.partner_information
                        .go_link,
                      promotionPageData.featured_promotion.partner_information
                        .slug
                    )
                  "
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  target="_blank"
                  class="
                    partner-name
                    promto-text
                    custom-font-1
                    cas-link
                    text-hover
                  "
                >
                  <span
                    class="bonus-text"
                    v-if="
                      promotionPageData.featured_promotion.short_descrp.length <
                      130
                    "
                    >{{
                      promotionPageData.featured_promotion.short_descrp
                    }}</span
                  >
                  <span class="bonus-text" v-else>{{
                    promotionPageData.featured_promotion.short_descrp.slice(
                      0,
                      130
                    ) + "..."
                  }}</span>
                </a>
              </div>
              <div class="mob-text">
                <a
                  v-if="
                    promotionPageData.featured_promotion.partner_information
                      .go_link
                  "
                  :title="
                    promotionPageData.featured_promotion.partner_information
                      .product_name
                  "
                  :href="
                    getGoLink(
                      promotionPageData.featured_promotion.partner_information
                        .go_link,
                      promotionPageData.featured_promotion.partner_information
                        .slug
                    )
                  "
                  :rel="
                    $root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'
                  "
                  target="_blank"
                  class="
                    partner-name
                    promto-text
                    custom-font-1
                    cas-link
                    text-hover
                  "
                >
                  <span
                    class="bonus-text"
                    v-if="
                      promotionPageData.featured_promotion.short_descrp.length <
                      100
                    "
                    >{{
                      promotionPageData.featured_promotion.short_descrp
                    }}</span
                  >
                  <span class="bonus-text" v-else>{{
                    promotionPageData.featured_promotion.short_descrp.slice(
                      0,
                      100
                    ) + "..."
                  }}</span>
                </a>
              </div>
            </div>
            <a
              v-if="
                promotionPageData.featured_promotion.partner_information &&
                promotionPageData.featured_promotion.partner_information.go_link
              "
              :title="
                promotionPageData.featured_promotion.partner_information
                  .product_name
              "
              :href="
                getGoLink(
                  promotionPageData.featured_promotion.partner_information
                    .go_link,
                  promotionPageData.featured_promotion.partner_information.slug
                )
              "
              :class="{
                'cta cta-primary cta-promotion ml-0 custom-btn btn-width cta-large hover-btn cas-link': true,
                'text-white game-btn':
                  !$root.override_ctabtntxt_color &&
                  !getContrastYIQ($root.color_schema.primary_btn),
                'text-gray':
                  !$root.override_ctabtntxt_color &&
                  getContrastYIQ($root.color_schema.primary_btn),
                'text-cta-override': $root.override_ctabtntxt_color,
              }"
              target="_blank"
              :rel="
                $root.change_cta_to_sponsored
                  ? 'nofollow sponsored'
                  : 'nofollow'
              "
              :style="{
                '--primary-btn': $root.color_schema.primary_btn,
                '--primary-btn-hover': pSBC(
                  -0.2,
                  $root.color_schema.primary_btn
                ),
              }"
              ><span class="cta-text">{{
                promotionPageData.featured_promotion.partner_information
                  .cta_button_text
              }}</span
              ><span
                class="hover-text"
                v-for="(char, indexGo) in $root.i18n.go_to_casino"
                :key="indexGo + `simpp`"
                >{{ char }}</span
              >
              <!--<span
                  class="hover-text"
                  v-for="(char, indexPro) in promotionPageData.featured_promotion.partner_information.product_name.split('')"
                  :key="indexPro + `sim`"
                  >{{ char }}</span
                >--></a
            >
            <span class="timer-text promto-time" v-if="timer_html.length > 0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="20"
                viewBox="0 0 18 20"
                fill="none"
              >
                <path
                  d="M13.1265 2.24486L12.4548 3.40718L14.7823 4.75061L15.454 3.58826C15.639 3.26561 15.5289 2.85623 15.2075 2.66983L14.0452 1.99809C13.7236 1.81188 13.313 1.92205 13.1265 2.24486Z"
                  fill="#FE4646"
                />
                <path
                  d="M8.9999 3.02484C9.42474 3.02484 9.83974 3.06641 10.2499 3.125V2.03781L11.1093 2.03124V0.625C11.1093 0.279543 10.8297 0 10.4843 0H7.52209C7.17664 0 6.89709 0.279543 6.89709 0.625V2.03124L7.7499 2.03781V3.125C8.16007 3.06641 8.57507 3.02484 8.9999 3.02484Z"
                  fill="#FE4646"
                />
                <path
                  d="M9 3.75C4.51268 3.75 0.875 7.38765 0.875 11.875C0.875 16.3624 4.51268 20 9 20C13.4873 20 17.125 16.3624 17.125 11.875C17.125 7.38765 13.4873 3.75 9 3.75ZM12.7969 15.6938L8.06248 12.4161V7.78889H9.42876V11.7003L13.5745 14.5705L12.7969 15.6938Z"
                  fill="#FE4646"
                />
              </svg>
              <span class="time-text">
                {{
                  $root.i18n.time_left.charAt(0).toUpperCase() +
                  $root.i18n.time_left.slice(1)
                }}:
              </span>
              <span class="text-bold" v-html="timer_html"></span>
            </span>
            <div
              class="terms promto-term"
              v-if="
                promotionPageData.featured_promotion.partner_information
                  .bonus_tc &&
                promotionPageData.featured_promotion.partner_information
                  .bonus_tc != ''
              "
            >
              <span
                class="terms_tc cas-term"
                v-if="
                  promotionPageData.featured_promotion.partner_information
                    .bonus_tc &&
                  promotionPageData.featured_promotion.partner_information
                    .bonus_tc != ''
                "
                v-html="
                  promotionPageData.featured_promotion.partner_information
                    .bonus_tc
                "
                :style="{ '--primary-btn': $root.color_schema.primary_btn }"
              ></span>
              <span
                class="
                  promotionPageData.featured_promotion.metadata.featured_promotion.partner_information-stroke
                "
                v-if="
                  promotionPageData.featured_promotion.partner_information
                    .bonus_tc &&
                  promotionPageData.featured_promotion.partner_information
                    .terms &&
                  promotionPageData.featured_promotion.partner_information
                    .bonus_tc != '' &&
                  promotionPageData.featured_promotion.partner_information
                    .terms != ''
                "
                >|</span
              >
              <a
                :rel="
                  $root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'
                "
                class="terms_tc cas-term"
                v-if="
                  promotionPageData.featured_promotion.partner_information
                    .terms &&
                  promotionPageData.featured_promotion.partner_information
                    .terms != ''
                "
                :title="
                  promotionPageData.featured_promotion.partner_information
                    .product_name
                "
                :href="
                  getGoLink(
                    promotionPageData.featured_promotion.partner_information
                      .term_link,
                    promotionPageData.featured_promotion.partner_information
                      .slug
                  )
                "
                target="_blank"
                >{{
                  promotionPageData.featured_promotion.partner_information.terms
                }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Promotion banner section -->

    <div
      :class="{
        'block-wrapper': true,
        'custom-background-image': $root.color_schema.site_bg_img,
      }"
      :style="{
        '--bg-image': `url(${$root.color_schema.site_bg_img}) repeat`,
        '--bg-color': $root.color_schema.site_bg_color,
      }"
    >
      <a
        class="main-tag cas-link"
        :href="getGoLink($root.goto_link, $root.slug)"
        v-if="$root.color_schema.site_bg_img"
        target="_blank"
        :rel="$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'"
      ></a>
      <div
        :class="{
          'custom-background-color': $root.color_schema.site_bg_img,
          'pb-25 pt-26': true,
        }"
        v-observer="mutationObserve"
      >
        <!-- Game banner section -->
        <section
          class="ct-article"
          v-if="
            !(
              promotionPageData &&
              promotionPageData.featured_promotion &&
              promotionPageData.featured_promotion.metadata &&
              promotionPageData.featured_promotion.partner_information &&
              Object.keys(
                promotionPageData.featured_promotion.partner_information
              ).length > 0
            )
          "
        >
          <div class="container overflow-auto">
            <!--Breadcrumps-->
            <div class="col-md-12" v-if="promotionPageData.breadcrumb">
              <Breadcrumb
                :breadcrumbData="promotionPageData.breadcrumb"
                :dark="true"
              />
            </div>
            <!--End Breadcrumps-->
          </div>
        </section>
        <!-- End Game banner section -->
        <!-- Horizontal Cards -->
        <template v-for="(data, index) in blockData">
          <CustomComponent :key="`${data.blockName}-${index}`" 
            :blockData="data" 
            :recommendSection="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? recommend_section : {}"
            :bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
            :blockIndex="index"
            />
        </template>
        <!-- Horizontal Cards ends -->
        <!--Related Page Links-->
        <template
          v-if="
            morePaymentBottom &&
            promotionPageData &&
            promotionPageData.content &&
            blockData.length === promotionPageData.content.blocks.length
          "
        >
          <RelatedLinks :relatedLinkData="morePaymentBottom" />
        </template>
        <!--End Related Page Links-->

        <!--Author Block-->
        <template
          v-if="
            auhtorBlockdata &&
            promotionPageData &&
            promotionPageData.content &&
            blockData.length === promotionPageData.content.blocks.length
          "
        >
        </template>
        <!--End Author Block-->
      </div>
    </div>
  </main>
</template>

<script>
import StarRating from "@/components/ui/StarRating";
import CustomComponent from '@/components/CustomComponent';
import Breadcrumb from "@/components/layouts/Breadcrumb";
import RelatedLinks from "@/components/custom-block/RelatedLinks";
import NotFound from "@/pages/404";

import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";
import { metaChanger } from "@/misc/meta-changer";
import { HttpService } from "@/api/Pages.api";

export default {
  name: "Promotions",
  props: ["promotionData"],
  data() {
    return {
      helpful: null,
      top_block: {
        type: Object,
        default: () => {},
      },
      assets_images: {
        type: Object,
        default: () => {},
      },
      morePaymentBottom: {
        type: Object,
        default: () => {},
      },
      promotionPageData: [],
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      top_casino_title: "",
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      timer_html: "",
      timer_width: "",
      strCls: "star-cls",
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      typeCheck: "",
      bluebar: {},
    };
  },
  components: {
    StarRating,
    Breadcrumb,
    CustomComponent,
    RelatedLinks,
    NotFound,
},
  created: function () {
    if (
      this.$root.routes_meta[this.$route.params.postSlug] &&
      this.$root.routes_meta[this.$route.params.postSlug].metaTags
    )
      this.metaChanger(
        this.$root.routes_meta[this.$route.params.postSlug].metaTags
      );
  },
  mounted: function () {
    if (this.promotionData != undefined) {
      this.promotionPageData = this.promotionData;
      // Schema Append
      document.getElementById("schema-script").innerHTML =
        this.promotionPageData.schema;

      // Blocks Filtered
      let title = this.promotionPageData.content.blocks.filter((ele) => {
        if (ele.blockName === "core/heading") {
          return ele.filtered_content;
        }
      });
      let content = this.promotionPageData.content.blocks.filter((ele) => {
        if (ele.blockName === "core/paragraph") {
          return ele.filtered_content;
        }
      });
      let emoji_section = this.promotionPageData.content.blocks.filter(
        (ele) => {
          if (ele.blockName === "core/html") {
            return ele.filtered_content;
          }
        }
      );
      this.top_block = { title, content, emoji_section };

      // More Payments Bottom Card
      this.morePaymentBottom = this.promotionPageData.meta.more_payment_method;

      // Author Blocks Filtered
      let atBlock = this.promotionPageData.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0)
        this.auhtorBlockdata = atBlock.shift().filtered_content;

      // RightContent Blocks Filtered
      let rightBlock = this.promotionPageData.content.blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0)
        this.rightBlockdata = rightBlock.shift().filtered_content;

      // Adminbar Data
      this.$root.adminBarData =
        Object.keys(this.promotionPageData.toolbar).length > 0
          ? this.promotionPageData.toolbar
          : "";
      this.$root.disable = this.$root.adminBarData
        ? this.$root.adminBarData.visible
        : false;

      // Assets Sizes
      this.assets_images =
        Object.keys(this.$root.asset_sizes).length > 0
          ? this.$root.asset_sizes
          : "";

      this.updateTimerPromo();
      this.interval = setInterval(this.updateTimerPromo, 60000);

      // if (this.$root.enable_lazyload) {
      //   this.blockData.push(
      //     this.promotionPageData.content.blocks[this.blockDataIndex]
      //   );
      //   this.blockDataIndex++;
      //   this.$root.show_footer = false;
      // } else {
      this.blockData = this.promotionPageData.content.blocks;
      this.$root.show_footer = true;
      //}
    } else {
      this.$root.loading = true;
      this.promotionPageData = [];
      this.getPageData();
    }
    if (
      this.scriptFlag === 0 &&
      this.promotionPageData.content.blocks.filter((ele) => {
        return (
          ele.blockName === "wpvcb/custom-youtube" ||
          ele.blockName === "wpvcb/youtube-film-strip"
        );
      }).length > 0
    ) {
      this.youtubeInit();
      this.scriptFlag++;
    }
    this.$nextTick(() => {
      this.updateBonusHeight();
      this.heightCheck();
    });
    var that = this;
    window.addEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.addEventListener("resize", () => {
      that.heightCheck();
      that.updateBonusHeight();
    });

    const meta = this.promotionPageData.meta;
    
    if (meta.bluebar) {
      this.bluebar = meta.bluebar;
    } else {
      this.bluebar = {};
    }
  },
  beforeDestroy() {
    window.removeEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.removeEventListener("resize", () => {
      that.heightCheck();
      that.updateBonusHeight();
    });
  },
  methods: {
    pSBC,
    getContrastYIQ,
    getOffset,
    metaChanger,
    getPartnerImg: function (assets) {
      let img_src = assets.filter(
        (ele) => ele.asset_category_name === "product_logo"
      )[0];
      if (Object.keys(img_src).length > 0 && img_src.url) {
        return img_src.url;
      } else {
        return null;
      }
    },
    updateBonusHeight: function () {
      let heightArr = [];
      document.querySelectorAll(".promto-text").forEach((ele) => {
        heightArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".promto-text").forEach((ele) => {
        ele.style.height = `${Math.max(...heightArr)}px`;
      });

      let heightTermArr = [];
      document.querySelectorAll(".promto-term").forEach((ele) => {
        heightTermArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".promto-term").forEach((ele) => {
        ele.style.height = `${Math.max(...heightTermArr)}px`;
      });

      let heightTimeArr = [];
      document.querySelectorAll(".promto-time").forEach((ele) => {
        heightTimeArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".promto-time").forEach((ele) => {
        ele.style.height = `${Math.max(...heightTimeArr)}px`;
      });
    },
    updateTimerPromo: function () {
      if (
        this.promotionPageData &&
        this.promotionPageData.featured_promotion &&
        Object.keys(this.promotionPageData.featured_promotion).length > 0
      ) {
        this.timer_html = "";
        let timer_calc =
          Date.parse(
            this.promotionPageData.featured_promotion.metadata
              .promotion_end_date
          ) +
          86400000 -
          Date.parse(new Date());
        let months = Math.floor(timer_calc / (1000 * 60 * 60 * 24 * 30));
        let days = Math.floor((timer_calc / (1000 * 60 * 60 * 24)) % 30);
        let hours = Math.floor(
          (timer_calc % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((timer_calc % (1000 * 60 * 60)) / (1000 * 60));
        if (months > 0) {
          this.timer_html += `<span class="fw-bold">${months}</span> ${
            this.$root.i18n.months.charAt(0).toUpperCase() +
            this.$root.i18n.months.slice(1)
          }, <span class="fw-bold">${days}</span> ${
            this.$root.i18n.days.charAt(0).toUpperCase() +
            this.$root.i18n.days.slice(1)
          }, <span class="fw-bold">${hours}</span> ${
            this.$root.i18n.hours.charAt(0).toUpperCase() +
            this.$root.i18n.hours.slice(1)
          }, <span class="fw-bold">${minutes}</span> ${
            this.$root.i18n.mins.charAt(0).toUpperCase() +
            this.$root.i18n.mins.slice(1)
          }`;
          this.timer_width = "300px";
        } else if (days > 0) {
          this.timer_html += `<span class="fw-bold">${days}</span> ${
            this.$root.i18n.days.charAt(0).toUpperCase() +
            this.$root.i18n.days.slice(1)
          }, <span class="fw-bold">${hours}</span> ${
            this.$root.i18n.hours.charAt(0).toUpperCase() +
            this.$root.i18n.hours.slice(1)
          }, <span class="fw-bold">${minutes}</span> ${
            this.$root.i18n.mins.charAt(0).toUpperCase() +
            this.$root.i18n.mins.slice(1)
          }`;
          this.timer_width = "260px";
        } else if (hours > 0) {
          this.timer_html += `<span class="fw-bold">${hours}</span> ${
            this.$root.i18n.hours.charAt(0).toUpperCase() +
            this.$root.i18n.hours.slice(1)
          }, <span class="fw-bold">${minutes}</span> ${
            this.$root.i18n.mins.charAt(0).toUpperCase() +
            this.$root.i18n.mins.slice(1)
          }`;
          this.timer_width = "220px";
        } else if (minutes > 0) {
          this.timer_html += `<span class="fw-bold">${minutes}</span> ${
            this.$root.i18n.mins.charAt(0).toUpperCase() +
            this.$root.i18n.mins.slice(1)
          }`;
          this.timer_width = "200px";
        } else {
          this.timer_html = "";
          this.timer_width = "200px";
        }
      }
    },
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function (mutations) {
      if (
        this.blockData.length < this.promotionPageData.content.blocks.length
      ) {
        let mainContentArea =
          this.getOffset(mutations[0].target).top +
          mutations[0].target.offsetHeight;
        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function () {
      if (
        this.blockData.length < this.promotionPageData.content.blocks.length
      ) {
        this.busy = true;
        this.incrementBlockDataValue();
        //this.heightCheck();
        this.busy = false;
      }
    },
    incrementBlockDataValue: function () {
      this.blockData = this.promotionPageData.content.blocks.slice(
        0,
        this.blockDataIndex + 1
      );
      this.blockDataIndex++;
    },
    itemFAQ: function (data) {
      let FAQitems = [];
      data.forEach((ele) => {
        let { id, faq_question: title, faq_answer: content } = ele;

        let is_active = false;
        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({ id, title, content, is_active });
      });
      return FAQitems;
    },
    getPageData: function () {
      HttpService.getBody(this.$route.params.postSlug, this.$root.user_id)
        .then((res) => {
          this.promotionPageData = res.data.data;
          // Schema Append
          document.getElementById("schema-script").innerHTML =
            this.promotionPageData.schema;

          // Blocks Filtered
          let title = this.promotionPageData.content.blocks.filter((ele) => {
            if (ele.blockName === "core/heading") {
              return ele.filtered_content;
            }
          });
          let content = this.promotionPageData.content.blocks.filter((ele) => {
            if (ele.blockName === "core/paragraph") {
              return ele.filtered_content;
            }
          });
          let emoji_section = this.promotionPageData.content.blocks.filter(
            (ele) => {
              if (ele.blockName === "core/html") {
                return ele.filtered_content;
              }
            }
          );
          this.top_block = { title, content, emoji_section };

          // More Payments Bottom Card
          this.morePaymentBottom =
            this.promotionPageData.meta.more_payment_method;

          // Author Blocks Filtered
          let atBlock = this.promotionPageData.content.blocks.filter((ele) => {
            if (ele.blockName === "wpvcb/author-block") {
              return ele.filtered_content;
            }
          });
          if (atBlock.length > 0)
            this.auhtorBlockdata = atBlock.shift().filtered_content;

          // RightContent Blocks Filtered
          let rightBlock = this.promotionPageData.content.blocks.filter(
            (ele) => {
              if (ele.blockName === "wpvcb/right-content-simpletoc") {
                return ele.filtered_content;
              }
            }
          );
          if (rightBlock.length > 0)
            this.rightBlockdata = rightBlock.shift().filtered_content;

          // Adminbar Data
          this.$root.adminBarData =
            Object.keys(this.promotionPageData.toolbar).length > 0
              ? this.promotionPageData.toolbar
              : "";
          this.$root.disable = this.$root.adminBarData
            ? this.$root.adminBarData.visible
            : false;

          // Assets Sizes
          this.assets_images =
            Object.keys(this.promotionPageData.asset_sizes).length > 0
              ? this.promotionPageData.asset_sizes
              : "";

          this.updateTimerPromo();
          this.interval = setInterval(this.updateTimerPromo, 60000);
          //if (!this.$root.enable_lazyload) {
          this.blockData = this.promotionPageData;
          this.blockDataIndex = this.promotionPageData.length;
          this.$root.show_footer = true;
          this.$root.body_loading_status = true;
          // } else {
          // if (!this.top_section) {
          //   this.blockData.push(this.promotionPageData[this.blockDataIndex]);
          //   this.blockDataIndex++;
          // }
          // this.$root.show_footer = false;
          //}
        })
        .catch((err) => {
          this.typeCheck = "error";
          this.$root.loading = false;
        });
    },
  },
  watch: {
    "$route.params.postSlug": function () {
      if (this.promotionPageData != undefined) {
      } else {
        this.$root.loading = true;
        this.promotionPageData = [];
        this.getPageData();
      }
    },
    blockData: function () {
      if (
        this.blockData.length === this.promotionPageData.content.blocks.length
      ) {
        this.$root.show_footer = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.pt-37 {
  padding-top: 37px;
}

.hide-mob {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
}

.casino-header {
  display: table;
  width: 100%;
  background: @darkblue;
  .border-radius(12px);
  h2 {
    text-align: center;
    color: @white;
    font-weight: bold;
    padding: 8px;
  }
}

.offer-card {
  .border-radius(12px);
  padding: 0 12px;
  position: relative;
  overflow: hidden;
  &:before {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.522118) 6.04%,
      rgba(0, 0, 0, 0.83) 100%
    );
    z-index: 0;
  }
  &-big {
    .timer-text {
      margin: 24px auto;
      svg {
        margin-right: 22px;
      }
    }
    .terms {
      display: block;
      @media (min-width: @sizes[small]) {
        display: none;
      }
    }
    &.suggested {
      border: 2px solid #0165f7;
    }
  }
  &-bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    img {
      object-fit: cover;
      height: 100%;
    }
  }
  &-meta {
    display: inline-flex;
    position: relative;
    top: 8px;
    @media (min-width: @sizes[small]) {
      position: relative;
      top: 12px;
    }
    @media (min-width: @sizes[md-large]) {
      position: absolute;
      top: 12px;
    }
  }
  &-logo {
    height: 50px;
    width: 50px;
    .border-radius(12px);
    overflow: hidden;
  }
  &-title {
    font-size: 16px;
    line-height: 115%;
    font-weight: bold;
    margin-left: 8px;
    color: @white;
    @media (min-width: @sizes[small]) {
      line-height: 150%;
    }
  }
  &-bonus {
    position: relative;
    width: 100%;
    margin: 20px auto;
    padding: 10px 16px 18px 16px;
    .border-radius(12px);
    border: 2px dashed #ffffff;
    .bonus-text {
      display: block;
      //width: calc(100% - 32px);
      margin: 0 auto;
      color: @white;
      text-align: center;
      font-size: 16px;
      line-height: 20px;
      font-weight: bold;
      @media (min-width: @sizes[small]) {
        font-size: 32px;
        line-height: 43px;
        width: 465px;
      }
    }
    @media (min-width: @sizes[small]) {
      width: 643px;
      padding: 27px;
      margin: 40px auto;
    }
    .mobile-tags {
      display: flex;
      justify-content: center;
      margin-bottom: 6px;
      span {
        padding: 7px 6px 5px 6px;
        font-size: 12px;
        line-height: 11px;
        margin: 0 3px;
        svg {
          top: 1px !important;
        }
      }
      @media (min-width: @sizes[small]) {
        display: none;
      }
    }
  }
  &-tags {
    position: absolute;
    top: 12px;
    right: 12px;
    display: none;
    span {
      display: block;
      margin-bottom: 7px;
      padding: 4px 12px;
      font-size: 12px;
      line-height: 18px;
    }
    @media (min-width: @sizes[small]) {
      display: inline-block;
    }
  }
  &-small {
    @media (min-width: @sizes[medium]) {
      width: 360px;
    }
    @media (min-width: @sizes[md-large]) {
      width: 380px;
    }
    .card-tags {
      display: flex;
      justify-content: center;
      margin-bottom: 6px;
      span {
        padding: 3px 6px;
        width: 64px;
        font-size: 8px;
        line-height: 8px;
        margin: 0 3px;
        svg {
          top: 1px !important;
        }
      }
    }
    .offer-card-meta {
      position: relative;
      top: 12px;
    }
    .offer-card-bonus {
      width: 100%;
      padding: 10px 16px 18px 16px;
      .bonus-text {
        font-size: 16px;
        line-height: 18px;
        width: calc(100% - 32px);
        font-family: var(--paragraph-font);
        @media (min-width: @sizes[small]) {
          font-size: 24px;
          line-height: 26px;
          width: 339px;
        }
      }
    }
  }
  .pro-promotion-tag {
    background: #ffd039;
    text-align: center;
    font-weight: 600;
    .border-radius(100px);
    svg {
      position: relative;
      top: 5px;
    }
  }
  .pro-suggestion-tag {
    color: white;
    background: #0165f7;
    text-align: center;
    font-weight: 600;
    .border-radius(100px);
    svg {
      position: relative;
      top: 5px;
    }
  }
  .cta {
    max-width: 375px;
    margin: 0 auto;
    display: block;
  }
  .timer-text {
    position: relative;
    margin: 14px auto;
    display: block;
    text-align: center;
    font-size: 12px;
    line-height: 15px;
    color: #fe4646;
    white-space: normal;
    margin-bottom: 24px;
    // text-align: center;
    @media (min-width: @sizes[medium]) {
      font-size: 16px;
      line-height: 19px;
    }
    @media (min-width: @sizes[large]) {
      font-size: 16px;
    }

    svg {
      vertical-align: text-bottom;
      margin-right: 6px;
      @media (min-width: @sizes[small]) {
        margin-right: 16px;
      }
    }
  }
  .terms {
    padding: 5px 11px;
    background: rgba(239, 241, 245, 0.1);
    margin: 0 -12px;
    text-align: center;
    span {
      font-size: 10px;
      line-height: 15px;
      color: #c4c7c9;
    }
  }
}

.text-bold {
  font-weight: 700;
  margin-left: 5px;
}

.wrapper-header {
  font-weight: 900;
  font-size: 26px;
  line-height: 31px;
  padding-bottom: 8px;
  display: flex;
  align-items: baseline;
  .hd-span {
    color: @white;
    margin-left: 12px;
  }
  @media (min-width: @sizes[medium]) {
    font-size: 36px;
    line-height: 54px;
  }
}

.img-desktop {
  width: 100%;
  object-fit: cover;
}
.img-mobile {
  display: block;
  height: 100%;
  width: 100%;
  object-position: center;
  object-fit: cover;
  @media (min-width: @sizes[extra-small]) {
  }
  @media (min-width: @sizes[large]) {
    display: none;
  }
}
.img-desktop {
  display: none;
  @media (min-width: @sizes[large]) {
    display: block;
  }
}

.star-cls {
  justify-content: normal !important;
}

.time-text {
  width: 70px;
  @media (min-width: @sizes[small]) {
    width: 75px;
  }
}

.partner-name {
  color: @white;
}
.pt-100 {
  img {
    width: 100%;
    height: 100%;
  }
  width: 100%;
  height: 100%;
}
.game-btn {
  position: relative;
}
.promto-term {
  position: relative;
}

.desk-text {
  display: none;
  @media (min-width: @sizes[small]) {
    display: block;
  }
}
.mob-text {
  display: block;
  @media (min-width: @sizes[small]) {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Promotions/Promotions.vue